<template>
  <v-layout column v-if="application">
    <qualification-form-dialog 
      :show.sync="showQualificationForm" 
      :qualification-form="application.qualification_form"
    />

    <v-flex>
      <v-subheader class="subheader-1">
        {{ application.locked_by === null ? 'Análise não iniciada' : 'Análise Iniciada por' }}
      </v-subheader>
      <v-card flat class="mb-2" v-if="application.locked_by">
        <v-list>
          <v-list-tile>
            <v-layout column align-start justify-start>
              <span class="mb-2 subheader-2" v-if="application.application_type">
               {{ application.locked_by.name }}
              </span>
            </v-layout>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>

    <v-flex>
      <v-subheader class="subheader-1">
        Boleto do Requerimento
      </v-subheader>
      <boleto-card :payment_slip="getPaymentSlip({ complementary: false })"></boleto-card>
    </v-flex>

    <v-flex>
      <v-subheader class="subheader-1">
        Boleto de Complemento
      </v-subheader>
      <additional-payment-slip v-if="!hasAdditionalPaymentSlip" :applicationId="application.id" />
      <boleto-card v-else :payment_slip="getPaymentSlip({ complementary: true })"></boleto-card>
    </v-flex>

    <v-flex>
      <v-subheader class="subheader-1">
        Requerimento
      </v-subheader>

      <v-card flat class="mb-2">
        <v-list>
          <v-list-tile>
              <span class="mb-2 subheader-2">
                ID: {{  application.id }}
              </span>
          </v-list-tile>
          <v-list-tile v-if="application.folder_number !== null">
            <span class="mb-2 subheader-2">
              {{ application.folder_number }}
            </span>
          </v-list-tile>
          <v-list-tile>
            <span class="mb-2 subheader-2" v-if="application.application_type">
              {{application.application_type.acronym}} -
              {{application.application_type.name}}
            </span>
          </v-list-tile>
          <v-list-tile>
            <span class="badge" v-bind:style="this.applicationChipColor">
              {{this.applicationChipText}}
            </span>
          </v-list-tile>
          <v-list-tile v-if="application.qualification_form && application.qualification_form.length > 0">
            <v-btn small color="primary" @click="openQualificationForm">
              <v-icon small left>mdi-file-document</v-icon>
              Formulário LAC
            </v-btn>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>

    <v-flex>
      <v-subheader class="subheader-1">
        Tipologia
      </v-subheader>

      <v-card flat class="mb-2">
        <v-card-text>
          <p>
            {{application.typology.code}} - {{application.typology.name}}
          </p>
          <p>
            Potencial Degradador: {{get(application, 'degrading_potential_for_tax.name', '---')}}
          </p>
          <p>
            Porte: {{get(application, 'size_for_tax.name', '---')}}
          </p>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-layout>
      <v-flex
      >
        <v-subheader
            class="pa-4 subheader-1">
          Solicitante
        </v-subheader>

        <v-card flat class="mb-2 pa-4">

          <v-layout column>
            <span class="solicitante"> {{this.application.person.name}}</span>
            <small class="grey--text">{{cpfCnpjText}}: {{formatCpfCnpj(this.application.person.cpf_cnpj)}}</small>
          </v-layout>

          <v-divider class="my-2"/>

          <v-layout column>
            <small class="text-uppercase grey--text text--darken-1">
              Endereço Residencial
            </small>
            <span>
                {{this.application.person.address.street}},
                {{this.application.person.address.number}} -
                {{this.application.person.address.complement}} -
                {{this.application.person.address.neighborhood}},
                {{this.application.person.address.city}} -
                {{this.application.person.address.state}}
                {{this.application.person.address.zip_code}}
              </span>
          </v-layout>

          <v-divider class="my-2"/>

          <v-layout column>
            <small class="text-uppercase grey--text text--darken-1">
              Endereço do Local
            </small>
            <span>
              {{this.application.address.street}}, {{this.application.address.number}} -
              {{this.application.address.complement}} -
              {{this.application.address.neighborhood}},
              {{this.application.address.city}} - {{this.application.address.state}}
              {{this.application.address.zip_code}}
            </span>
          </v-layout>

          <v-divider class="my-2"/>

          <v-layout column>
            <small class="text-uppercase grey--text text--darken-1">
              Coordenadas (SIRGAS 2000)
            </small>
            <span>
              {{this.application.address.latitude}}, {{this.application.address.longitude}}
            </span>
          </v-layout>

          <v-divider class="my-2"/>

          <v-layout column
                    v-if="application.mailing_address">
            <small class="text-uppercase grey--text text--darken-1">
              Endereço de Correspondência
            </small>
            <span>{{ application.responsible_name }}</span>
            <span>{{ application.cellphone }}</span>
            <span>
                {{application.mailing_address.street}},
                {{application.mailing_address.number}} -
                {{application.mailing_address.complement}} -
                {{application.mailing_address.neighborhood}},
                {{application.mailing_address.city}} -
                {{application.mailing_address.state}}
                {{application.mailing_address.zip_code}}
              </span>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    
  </v-layout>


</template>

<script>
  import { get, isEmpty } from 'lodash';
  import colors from 'vuetify/es5/util/colors';
  import BoletoCard from '@/components/application/BoletoCard';
  import AdditionalPaymentSlip from '@/components/application/show/AdditionalPaymentSlip';
  import formatCpfCnpj from '@/utils/formatCpfCnpj';
  import QualificationFormDialog from '@/components/application/show/QualificationFormDialog';

  export default {
    name: 'SidebarShowApplication',
    props: ['application'],
    components: {
      BoletoCard,
      AdditionalPaymentSlip,
      QualificationFormDialog,
    },
    data() {
      return {
        showQualificationForm: false
      };
    },
    methods: {
      get,
      formatCpfCnpj,
      getPaymentSlip({ complementary }) {
        return this.application.payment_slips.find(payment_slip => payment_slip.complementary == complementary);
      },
      openQualificationForm() {
        console.log('Opening qualification form dialog, form data:', this.application.qualification_form);
        this.showQualificationForm = true;
      },
    },
    computed: {
      cpfCnpjText() {
        if (isEmpty(this.application.person.cpf_cnpj))
          return '';
        return this.application.person.cpf_cnpj.length === 11 ? 'CPF' : 'CNPJ'
      },
      applicationChipColor() {
        return {
          waiting_to_be_sent: { background: colors.grey.darken2, color: 'white' },
          waiting_for_review: { background: colors.amber.base, color: 'white' },
          in_review: { background: colors.amber.base, color: 'white' },
          pending: { background: colors.red.base, color: 'white' },
          done: { background: colors.green.base, color: 'white' },
        }[this.application.status];
      },
      applicationChipText() {
        return {
          waiting_to_be_sent: 'Aguardando o envio',
          waiting_for_review: 'Aguardando análise',
          in_review: 'Em análise',
          pending: 'Pendente',
          done: 'Aprovado',
        }[this.application.status];
      },
      hasAdditionalPaymentSlip() {
        return this.application.payment_slips.find(payment_slip => payment_slip.complementary);
      },
    },
  };
</script>
